import React, { Component } from 'react';

import { Route, Switch, Redirect } from 'react-router-dom';

import App from './App';
import Login from './Login';
import EmailLogin from './EmailLogin';
import Identify from './Identify';
import Edit from './UpdatePassword';

const PrivateRoute = ({ component: Component, ...rest }) => (

  <Route
    {...rest}
    render={props =>
      (localStorage.getItem('token') !== null) ? (
        <Component {...props} />
      ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
    }
  />
);

class Home extends Component {

  render() {
    return (
      <Switch>
        <PrivateRoute path="/app" component={App} />
        <Route path="/login" component={Login} />
        <Route path="/emailLogin" component={EmailLogin} />
        <Route path="/identify/:token/edit" component={Edit} />
        <Route path="/identify" component={Identify} />
        <PrivateRoute path="/" component={App} />
      </Switch>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// src/components/Home.js